import React from "react";
import { InputText } from "..";

import CashMaskedInput from "./components/CashMaskedInput";
import GenericMaskedInput from "./components/GenericMaskedInput";
import NumberMaskedInput from "./components/NumberMaskedInput";

function InputMask({
  format,
  prefix,
  mask,
  placeholder = "",
  value,
  onChange = () => {},
  type = "generic",
  ...props
}) {
  const getTypeMask = () => {
    switch (type) {
      case "generic":
        return (
          <GenericMaskedInput
            format={format}
            prefix={prefix}
            mask={mask}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            customInput={InputText}
            {...props}
          />
        );
      case "number":
        return (
          <NumberMaskedInput
            customInput={InputText}
            onChange={onChange}
            value={value}
            {...props}
          />
        );
      case "cash":
        return (
          <CashMaskedInput
            format={format}
            mask={mask}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            customInput={InputText}
            prefix={prefix}
            {...props}
          />
        );
      default:
        break;
    }
  };

  return getTypeMask();
}
export default InputMask;